<script lang="ts">
	import { fade } from 'svelte/transition';
	import { BaseTooltip } from '@shared/svelte';
	import logoSrc from '$lib/assets/icons/logo.png';
	import t from '$i18n';

	/**
	 * The link url.
	 *
	 * @default undefined
	 */
	export let link: string | undefined = undefined;

	const size = 75;
</script>

<BaseTooltip disabled={!link}>
	<span slot="hint"> {$t.go_back()} </span>

	<a href={link} class="flex items-center">
		<img src={logoSrc} alt="LocaleKey" in:fade height={size} width={size} />
	</a>
</BaseTooltip>
